export enum FieldCategoryType {
  Generic = "Generic",
  Custom = "Custom",
}
